var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_Saved_Cards",
    "data-name": "Icon_Saved Cards",
    width: 126.641,
    height: 116.509,
    viewBox: "0 0 126.641 116.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M119.042,60.787V48.123A20.322,20.322,0,0,0,98.78,27.861H20.262a7.678,7.678,0,0,1-7.6-7.852,7.789,7.789,0,0,1,7.852-7.345H98.78a7.3,7.3,0,0,1,6.585,4.052,6.438,6.438,0,0,0,5.825,3.546,6.332,6.332,0,0,0,5.572-9.371A19.924,19.924,0,0,0,98.78,0H20.262A20.322,20.322,0,0,0,0,20.262H0V96.247a20.322,20.322,0,0,0,20.262,20.262H98.78a20.322,20.322,0,0,0,20.262-20.262V83.583H106.378V96.247a7.62,7.62,0,0,1-7.6,7.6H20.262a7.62,7.62,0,0,1-7.6-7.6V39.005a18.506,18.506,0,0,0,7.6,1.52H98.78a7.62,7.62,0,0,1,7.6,7.6V60.787Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(68.386 53.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M72.591,33.664V46.328H39.664V33.664H72.591M74.364,21H37.891A10.81,10.81,0,0,0,27,31.891V48.1A10.81,10.81,0,0,0,37.891,58.992H74.364A10.81,10.81,0,0,0,85.255,48.1V31.891A10.81,10.81,0,0,0,74.364,21Z",
    transform: "translate(-27 -21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8aa2a683204c9e6c3f71715e91845fde.svg";
export { ForwardRef as ReactComponent };